import { useEffect } from 'react';
import { useProductName } from '@atlassian/jira-tenant-context-controller/src/components/product-name/index.tsx';
import useIsAdminHubAIEnabled from '@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled/src/controllers/index.tsx';
import { getProductForAdminHubAi } from './utils.tsx';

/**
 * Hook for retrieving AI enablements for backlog.
 * Gets product name from context and coverts it to usable value for
 * /rest/api/${version}/aiconfig/ai-enabled/${jiraProduct} API
 * @returns {boolean} isAiEnabled
 */
export const useIsAiEnabledBacklog = (): boolean => {
	const productName = useProductName();
	const adminHubAiProductName = getProductForAdminHubAi(productName);
	const {
		data: isAiEnabled,
		fetchAIEnablement,
		error,
	} = useIsAdminHubAIEnabled(adminHubAiProductName);

	useEffect(() => {
		fetchAIEnablement();
	}, [fetchAIEnablement]);

	// Boolean constructor used as it can be null
	return !error && Boolean(isAiEnabled);
};
